import useAppModes from 'hooks/useAppModes'
import useFlowName from '@order/hooks/useFlowName'

const useAvatarFlow = () => {
  const flowName = useFlowName()

  const { isAvatar } = useAppModes()

  return {
    isAvatarFlow: isAvatar && flowName === 'avatar',
    isAvatar,
  }
}

export default useAvatarFlow
